/* QOWAA FIT — Page panier (/cart). MAJ AJAX via Shopify Cart API.
   Dépend de window.QowaaTiers (qowaa-tiers.js, chargé avant via la section).
   GA4 (dataLayer, push défensif) : cart_qty_change, cart_item_remove,
   cart_cross_sell_add, begin_checkout. prefers-reduced-motion respecté via CSS. */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  var QT = window.QowaaTiers || null;
  function money(cents) { return QT ? QT.money(cents) : ((cents || 0) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function dl(ev, extra) {
    if (QT) { QT.dl(ev, extra); return; }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      var o = { event: ev }; if (extra) for (var k in extra) o[k] = extra[k];
      window.dataLayer.push(o);
    }
  }

  function initCartPage() {
    QT = window.QowaaTiers || QT;
    var root = $('[data-qw-cart]');
    if (!root) return; // les barres hors page panier sont gérées par qowaa-tiers.js

    var freeThreshold = parseInt(root.getAttribute('data-free-threshold'), 10); // cents, -1 = jamais
    var shippingUnderLabel = root.getAttribute('data-shipping-under-label') || 'Calculés au paiement';
    var busy = false;

    // ── Cadeau automatique (cache-nombril offert au palier) ──────────────────
    // Principe : on AJOUTE une ligne cadeau en plus (marquée _qw_gift), on ne touche
    // jamais aux lignes payantes. La remise Shopify « Cache nombril OFFERT ! » met
    // CETTE ligne à 0 → le total des produits ne bouge pas, un cache-nombril s'ajoute.
    var giftEnabled = root.getAttribute('data-qw-gift-enabled') === '1';
    var giftThreshold = parseInt(root.getAttribute('data-qw-gift-threshold'), 10); // cents
    var giftProductId = parseInt(root.getAttribute('data-qw-gift-product'), 10);   // détection des cache-nombril
    var giftVariantId = parseInt(root.getAttribute('data-qw-gift-variant'), 10);   // variante ajoutée
    if (isNaN(giftThreshold)) giftThreshold = -1;
    if (isNaN(giftProductId)) giftProductId = 0;
    if (isNaN(giftVariantId)) giftVariantId = 0;

    function setBusy(b) { busy = b; root.style.opacity = b ? '0.6' : ''; root.style.pointerEvents = b ? 'none' : ''; }

    function updateHeaderBadge(count) {
      $all('.header__badge').forEach(function (b) { b.textContent = count; b.style.display = count > 0 ? '' : 'none'; });
    }

    function applyCart(cart) {
      $all('[data-qw-cart-item]', root).forEach(function (node) {
        var key = node.getAttribute('data-line-key');
        var line = null;
        for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].key === key) { line = cart.items[i]; break; } }
        if (!line) { node.remove(); return; }
        $all('[data-qw-qty-val]', node).forEach(function (v) { v.textContent = line.quantity; });
        $all('[data-qw-qty-minus]', node).forEach(function (b) { b.disabled = line.quantity <= 1; });
        var price = $('[data-qw-line-price]', node);
        if (price) price.textContent = money(line.final_line_price);
      });

      var sub = $('[data-qw-subtotal]', root); if (sub) sub.textContent = money(cart.items_subtotal_price);
      var tot = $('[data-qw-total]', root); if (tot) tot.textContent = money(cart.total_price);
      var shipLine = $('[data-qw-shipping-line]', root);
      var shipAmt = $('[data-qw-shipping-amount]', root);
      var free = freeThreshold >= 0 && cart.items_subtotal_price >= freeThreshold;
      if (shipLine) shipLine.classList.toggle('cart-recap__line--free', free);
      if (shipAmt) shipAmt.textContent = free ? 'Offerte' : shippingUnderLabel;

      updateHeaderBadge(cart.item_count);
      var countLine = $('[data-qw-cart-count-line]', root);
      if (countLine) countLine.textContent = cart.item_count + ' article' + (cart.item_count > 1 ? 's' : '');

      if (window.QowaaTiers) window.QowaaTiers.refresh(cart);

      if (cart.item_count === 0) { window.location.reload(); }
    }

    function changeQty(key, qty, ev) {
      if (busy) return;
      setBusy(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { applyCart(cart); dl(ev || 'cart_qty_change', { quantity: qty }); ensureGift(cart); })
        .catch(function () {})
        .finally(function () { setBusy(false); });
    }

    // Une ligne est le cadeau auto si elle porte la propriété _qw_gift (≠ cache-nombril acheté).
    function isGiftLine(it) {
      return !!(it.properties && it.properties._qw_gift);
    }

    // Ajoute / retire la ligne cadeau selon le sous-total des produits HORS cache-nombril.
    // Retourne true si une action (qui recharge la page) a été déclenchée.
    function ensureGift(cart) {
      if (!giftEnabled || !giftVariantId || giftThreshold < 0) return false;
      if (!cart || cart.item_count === 0) return false;

      var cnFinalSum = 0;   // total des cache-nombril (payants + cadeau) après remise
      var giftKey = null, giftCount = 0, extraGiftKeys = [];
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (giftProductId && it.product_id === giftProductId) cnFinalSum += it.final_line_price;
        if (isGiftLine(it)) {
          if (giftKey === null) { giftKey = it.key; giftCount = it.quantity; }
          else { extraGiftKeys.push(it.key); }
        }
      }
      // Sous-total qualifiant = produits hors cache-nombril (aligné sur la remise Shopify).
      var qualifying = cart.items_subtotal_price - cnFinalSum;
      var hasGift = giftKey !== null;

      function reloadAfter(promise) { setBusy(true); promise.then(function () { window.location.reload(); }).catch(function () { setBusy(false); }); return true; }

      // Doublon de cadeau (ne devrait pas arriver) → on nettoie.
      if (extraGiftKeys.length) {
        return reloadAfter(fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: extraGiftKeys[0], quantity: 0 }) }));
      }
      // Cadeau présent mais on est repassé sous le seuil → on le retire.
      if (hasGift && qualifying < giftThreshold) {
        return reloadAfter(fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: giftKey, quantity: 0 }) }));
      }
      // Cadeau en quantité > 1 → on ramène à 1.
      if (hasGift && giftCount > 1) {
        return reloadAfter(fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: giftKey, quantity: 1 }) }));
      }
      // Seuil atteint, pas encore de cadeau → on l'ajoute en plus.
      if (!hasGift && qualifying >= giftThreshold) {
        return reloadAfter(fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: giftVariantId, quantity: 1, properties: { _qw_gift: '1' } }] }) }));
      }
      return false;
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var item = t.closest('[data-qw-cart-item]');

      // Changement de taille du cadeau : on retire la ligne cadeau actuelle et on
      // ré-ajoute la taille choisie (toujours marquée _qw_gift) → reste « Offert ».
      var sizeBtn = t.closest('[data-qw-gift-size]');
      if (sizeBtn) {
        e.preventDefault();
        if (busy || sizeBtn.disabled || sizeBtn.classList.contains('is-active')) return;
        var newVid = parseInt(sizeBtn.getAttribute('data-variant-id'), 10);
        var lineKey = sizeBtn.getAttribute('data-line-key');
        if (!newVid || !lineKey) return;
        setBusy(true);
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: lineKey, quantity: 0 }) })
          .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: newVid, quantity: 1, properties: { _qw_gift: '1' } }] }) }); })
          .then(function () { window.location.reload(); })
          .catch(function () { setBusy(false); });
        return;
      }

      if (t.closest('[data-qw-qty-plus]') && item) {
        var q1 = parseInt($('[data-qw-qty-val]', item).textContent, 10) || 1;
        changeQty(item.getAttribute('data-line-key'), q1 + 1, 'cart_qty_change'); return;
      }
      if (t.closest('[data-qw-qty-minus]') && item) {
        var q2 = parseInt($('[data-qw-qty-val]', item).textContent, 10) || 1;
        if (q2 <= 1) return;
        changeQty(item.getAttribute('data-line-key'), q2 - 1, 'cart_qty_change'); return;
      }
      if (t.closest('[data-qw-remove-start]') && item) {
        $('[data-qw-remove-start]', item).hidden = true;
        $('[data-qw-remove-confirm]', item).hidden = false; return;
      }
      if (t.closest('[data-qw-remove-no]') && item) {
        $('[data-qw-remove-confirm]', item).hidden = true;
        $('[data-qw-remove-start]', item).hidden = false; return;
      }
      if (t.closest('[data-qw-remove-yes]') && item) {
        changeQty(item.getAttribute('data-line-key'), 0, 'cart_item_remove'); return;
      }

      var addBtn = t.closest('[data-qw-xadd]');
      if (addBtn) {
        e.preventDefault(); e.stopPropagation();
        var vid = addBtn.getAttribute('data-variant-id');
        if (!vid || busy) return;
        setBusy(true);
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        })
          .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            applyCart(cart);
            var card = addBtn.closest('[data-qw-xcard]'); if (card) card.hidden = true;
            dl('cart_cross_sell_add', { variant_id: vid });
            ensureGift(cart);
          })
          .catch(function () {})
          .finally(function () { setBusy(false); });
        return;
      }
    });

    var checkout = $('[data-qw-checkout]', root);
    if (checkout) checkout.addEventListener('click', function () { dl('begin_checkout'); });

    // Au chargement : aligne l'état du cadeau (ajoute si le seuil est déjà atteint, retire sinon).
    if (giftEnabled) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { ensureGift(cart); })
        .catch(function () {});
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCartPage);
  else initCartPage();
})();
